import { render, staticRenderFns } from "./Text2Sell.vue?vue&type=template&id=2d30c6a0&lang=pug"
import script from "./Text2Sell.vue?vue&type=script&lang=js"
export * from "./Text2Sell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports